import { GET_GLOBAL_VENDORS, GET_GLOBAL_VENDORS_SUCCESS, GET_GLOBAL_VENDORS_ERROR, GET_GLOBAL_VENDORS_EMPTY } from '../../actions';

const initialState = {
  data: null,
  message: null,
  loading: false,
  success: false,
  error: false,
};

const GetGlobalVendors = (state = initialState, action) => {
  switch (action.type) {
    case GET_GLOBAL_VENDORS:
      return { ...state, loading: true, success: false, error: false, message: null };

    case GET_GLOBAL_VENDORS_SUCCESS:
      return { ...state, data: action.payload, loading: false, success: true, error: false };

    case GET_GLOBAL_VENDORS_ERROR:
      return { ...state, data: null, loading: false, success: false, error: true, message: action.payload };

    case GET_GLOBAL_VENDORS_EMPTY:
      return { ...initialState };

    default:
      return state;
  }
};

export default GetGlobalVendors;
